import * as z from "zod";
import { automationTestSchema } from "./automation-tests";

/** A test block's scenario: the event plus canned answers for lookups, effects, events and time. */
export const scenarioSchema = automationTestSchema.shape.scenario;
export type AutomationScenario = z.infer<typeof scenarioSchema>;

/** Serialized length, or Infinity for what can't be serialized (cycles, too deep). */
export function serializedLength(value: unknown): number {
  try {
    return JSON.stringify(value)?.length ?? 0;
  } catch {
    return Infinity;
  }
}

/** Simulation runs on the request thread, so a scenario is capped like a definition. */
export const SCENARIO_LIMITS = { entries: 500, characters: 1_000_000 } as const;

export const scenarioInputSchema = scenarioSchema.superRefine(
  (scenario, ctx) => {
    if (serializedLength(scenario) > SCENARIO_LIMITS.characters) {
      ctx.addIssue({
        code: "custom",
        message: `A scenario can be at most ${SCENARIO_LIMITS.characters} characters`,
      });
    }
    const counts = {
      records: Object.keys(scenario.records ?? {}).length,
      resolvers: Object.keys(scenario.resolvers ?? {}).length,
      events: scenario.events?.length ?? 0,
      timeline: scenario.timeline?.length ?? 0,
      refreshes: scenario.refreshes?.length ?? 0,
    };
    for (const [key, count] of Object.entries(counts)) {
      if (count > SCENARIO_LIMITS.entries) {
        ctx.addIssue({
          code: "custom",
          path: [key],
          message: `A scenario can have at most ${SCENARIO_LIMITS.entries} ${key}`,
        });
      }
    }
  },
);
